import React from 'react';
import { BsBag, BsBraces, BsDiamond, BsXDiamondFill } from 'react-icons/bs';
import { FaRegEye, FaWalking } from 'react-icons/fa';
import { GrMapLocation } from 'react-icons/gr';
import { ImLocation, ImLocation2 } from 'react-icons/im';
import { MdAnimation, MdErrorOutline, MdOutlineImageNotSupported } from 'react-icons/md';
import { VscDebugAlt } from 'react-icons/vsc';
export let ElementIconType;

(function (ElementIconType) {
  ElementIconType[ElementIconType["MapPlacementSelector"] = 0] = "MapPlacementSelector";
  ElementIconType[ElementIconType["ActionEditorSelector"] = 1] = "ActionEditorSelector";
  ElementIconType[ElementIconType["PartOfText"] = 2] = "PartOfText";
})(ElementIconType || (ElementIconType = {}));

const mapPlacementSelectorIconSize = 40;
const actionEditorSelectorIconSize = 50;

function getPropertiesFromProps(props) {
  switch (props.type) {
    case ElementIconType.MapPlacementSelector:
      return {
        size: mapPlacementSelectorIconSize
      };

    case ElementIconType.ActionEditorSelector:
      return {
        size: actionEditorSelectorIconSize
      };

    case ElementIconType.PartOfText:
      return {
        size: undefined
      };

    default:
      throw new Error("Not implemented");
  }
}

export const ElementIconMapMarker = props => /*#__PURE__*/React.createElement(ImLocation, getPropertiesFromProps(props));
export const ElementIconStartMarker = props => /*#__PURE__*/React.createElement(ImLocation2, getPropertiesFromProps(props));
export const ElementIconAreaTrigger = props => /*#__PURE__*/React.createElement(BsDiamond, getPropertiesFromProps(props));
export const ElementIconDebugStartMarker = props => /*#__PURE__*/React.createElement(VscDebugAlt, getPropertiesFromProps(props));
export const ElementIconTile = props => /*#__PURE__*/React.createElement(BsXDiamondFill, getPropertiesFromProps(props));
export const ElementAnimation = props => /*#__PURE__*/React.createElement(MdAnimation, getPropertiesFromProps(props));
export const ElementCharacter = props => /*#__PURE__*/React.createElement(FaWalking, getPropertiesFromProps(props));
export const ElementIconViewAreaTrigger = () => /*#__PURE__*/React.createElement(FaRegEye, {
  size: actionEditorSelectorIconSize
});
export const ElementParameter = () => /*#__PURE__*/React.createElement(BsBraces, {
  size: actionEditorSelectorIconSize
});
export const NoMapElementIcon = () => /*#__PURE__*/React.createElement(GrMapLocation, {
  size: actionEditorSelectorIconSize
});
export const MapElementErrorIcon = () => /*#__PURE__*/React.createElement(MdErrorOutline, {
  size: actionEditorSelectorIconSize
});
export const NoItemIcon = () => /*#__PURE__*/React.createElement(BsBag, {
  size: actionEditorSelectorIconSize
});
export const ItemImageMissingIcon = () => /*#__PURE__*/React.createElement(MdOutlineImageNotSupported, {
  size: actionEditorSelectorIconSize
});